import {Injectable} from "@angular/core";
import {IAppState} from "../../state/app.state";
import {Store} from "@ngrx/store";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {EResourcesActions, GetResources, GetResourcesFailure, GetResourcesSuccess, SetCurrentResource, SetCurrentResourceFailure, SetCurrentResourceSuccess, TranslateResources} from "../../actions/resources/resources.actions";
import {catchError, concatMap, map, switchMap, tap, withLatestFrom} from "rxjs/operators";
import {of} from "rxjs";
import {logger} from "@retail-data-factory/rdf-angular-utils";
import {Router} from "@angular/router";
import {emptyResource, emptyResourceGroup, IResource, IResourceGroup} from "@retail-data-factory/rdf-angular-types-api";
import {ApiPlatformService} from "../../../../api/external/api-services/api-platform/api-platform.service";
import {AuthenticateWorkflow, Logout} from "../../actions/security/authentication.actions";
import {ConfigurationManager} from "../../../configuration-manager/configuration-manager";
import {Presenter} from "../../../../api/internal/presenter/presenter";
import {LoggerService} from "../../../../services/external-api/logger.service";

@Injectable()
export class ResourcesEffects {
  Resources$ = createEffect(() => this._actions$.pipe(
    ofType<GetResources>(EResourcesActions.GetResources),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        return this.apiPlatformService.getResources(storeState.authentication.data.accessToken)
          .pipe(
            map(
              result => {
                console.log('GetResources effect');
                console.log(result);
                const resourcesArray: Array<IResource> = [];
                const resourceGroupsArray: Array<IResourceGroup> = [];
                const main = result.report.find(t=>t['Resource Code'] === 'MAIN');
                if (!main) {
                  result.report.push({
                    "Application ID": "10",
                    "Application Code": "REDMAIN",
                    "Application Name": "Main",
                    "Application Description": "Main page",
                    "Application Icon": "check-circle",
                    "Application URL": "/main",
                    "Resource ID": "-1",
                    "Resource Code": "MAIN",
                    "Resource Name": "Main",
                    "Resource Description": "Main page",
                    "Resource Icon": "check-circle",
                    "Resource Type": "SCREEN",
                    "app_profile": {
                      "default_name": {
                        "name": "Главная страница",
                        "shortname": "Главная страница",
                        "description": "Главная страница"
                      },
                      "translation": {
                        "ru": {
                          "name": "Главная страница",
                          "shortname": "Главная страница",
                          "description": "Главная страница"
                        },
                        "en": {
                          "name": "Main page",
                          "shortname": "Main page",
                          "description": "Main page"
                        },
                        "ro": {
                          "name": "",
                          "shortname": "",
                          "description": ""
                        },
                        "fr": {
                          "name": "",
                          "shortname": "",
                          "description": ""
                        },
                        "ua": {
                          "name": "",
                          "shortname": "",
                          "description": ""
                        }
                      }
                    },
                    "resource_profile": {
                      "default_name": {
                        "name": "Главная страница",
                        "shortname": "Главная страница",
                        "description": "Главная страница"
                      },
                      "translation": {
                        "ru": {
                          "name": "Главная страница",
                          "shortname": "Главная страница",
                          "description": "Главная страница"
                        },
                        "en": {
                          "name": "Main page",
                          "shortname": "Main page",
                          "description": "Main page"
                        },
                        "ro": {
                          "name": "",
                          "shortname": "",
                          "description": ""
                        },
                        "fr": {
                          "name": "",
                          "shortname": "",
                          "description": ""
                        },
                        "ua": {
                          "name": "",
                          "shortname": "",
                          "description": ""
                        }
                      }
                    },
                    "is_transferable": 0,
                    "order_no": 0
                  });
                }
                result['report'].forEach((item) => {

                  const resource: IResource = {
                    ...emptyResource,

                    id: item['Resource ID'],
                    code: item['Resource Code'],
                    name: item['Resource Name'],
                    description: item['Resource Description'],
                    url: item['Application URL'],
                    img: item['Resource Icon'],
                    type: item['Resource Type'],
                    orderNo: item['order_no']?item['order_no'].toString():'0',

                    statusCode: item['resource_status']?item['resource_status']:'ENABLED',
                    groupId: item['Application ID'],
                    groupCode: item['Application Code'],
                    groupName: item['Application Name'],
                    profile: item['resource_profile']
                  };
                  if (resource.code === 'MDM_ORGANISATION' && this.configurationManager.configuration.theme === 'auchan') {
                    //resource.url = '/organisation';
                    resource.profile = {...resource.profile, url: "/organisation"};
                  }
                  if (resource.code === 'MDM_SUPPLIERS' && this.configurationManager.configuration.theme === 'auchan') {
                    resource.profile = {...resource.profile, url: "/supplier"};
                  }
                  if (resource.code === 'MDM_CALENDAR' && this.configurationManager.configuration.theme === 'auchan') {
                    resource.profile = {...resource.profile, url: "/calendar"};
                  }
                  // if (resource.code ==='ORDERS_BASKET') {
                  //   resource.type ='BUTTON';
                  //   resource.name = 'Заказ';
                  //   resource.profile['translation']['ru']['name']= 'Заказ';
                  //   resource.profile['translation']['ru']['shortname']= 'Заказ';
                  //
                  // }
                  resourcesArray.push(resource);

                  let group: IResourceGroup = resourceGroupsArray.find(groupItem => groupItem.code === resource.groupCode);
                  if (group === undefined) {
                    group = {
                      ...emptyResourceGroup,
                      id: resource.groupId,
                      code: resource.groupCode,
                      name: resource.groupName,
                      description: item['Application Description'],
                      img: '/img/app_icons/icon1.png',//resource.img,
                      url: resource.url,
                      profile: item['app_profile'],

                      resources: []
                    };
                    if (group.code === 'REDMDM' && !group.url && this.configurationManager.configuration.theme === 'auchan') {
                      group.url = '/mdm';
                    }
                    resourceGroupsArray.push(group);
                  }
                  group.resources.push(resource);

                });
                /*
                const curReport = selectedParameters.report.getValue();
                if (curReport.groupCode === '' && curReport.code === '') {
                  const foundedResource = resourcesArray.find(item => item.url === ('/'+environment.start_page));
                  if (foundedResource) {
                    selectedParameters.report.next( foundedResource);
                  }
                }

                 */
                //return new GetResourcesSuccess(resourcesArray);
                return new GetResourcesSuccess(
                  {
                    resources: resourcesArray,
                    resourceGroups: resourceGroupsArray
                  }
                );
              }
            ),
            catchError(error => {
                console.log(error);
                if (error['status'] === 401) {
                  this._store$.dispatch(new Logout());
                }
                return of(new GetResourcesFailure());
              }
            )
          );
      }
    )
  ));

  GetResourcesSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<GetResourcesSuccess>(EResourcesActions.GetResourcesSuccess),
    withLatestFrom(this._store$),
    tap(([action, storeState]) => {

      //Переходим на стартовую страницу после логина - иначе глючит при разлогауте
      const startPage = storeState.authenticatedUser.data.selectedPartyProfile.startPage?storeState.authenticatedUser.data.selectedPartyProfile.startPage:this.configurationManager.configuration.start_page;

      this._router.navigateByUrl(`/${startPage}` ).catch(error => console.error(error));
      let foundedWorkflowResource = false;
      storeState.resources.data.resourceGroups.forEach(group => {
        if (group.code === 'REDWORKFLOW' || group.code === 'REDASSORTMENT' || group.code === 'REDPURCHASEPRICES') {
          foundedWorkflowResource = true;
        }
      });
      if (storeState.resources.data.resourceGroups.find(t => t.code === 'REDWORKFLOW' || t.code === 'REDASSORTMENT' || t.code === 'REDPURCHASEPRICES')) {
        if (!storeState.authentication.data.workflowToken && (this.configurationManager.theme === 'auchan' || this.configurationManager.theme === 'portal')) {
          this._store$.dispatch(new AuthenticateWorkflow());
        }
      }
      /*

        logger.print('GetResourcesSuccess started', 'info');
        const curReport = storeState.currentResource;
        let curRoute = window.location.pathname;//this._router.url;
        logger.print(`Router currentRoute ${curRoute}`, "info");
        if (curRoute === '/') {
          curRoute = '/' + this.configurationManager.configuration.start_page;
        }
        if (curReport.groupCode === '' && curReport.code === '') {
          const foundedResource: IResource = storeState.resources.data.resources.find(item => item.url === curRoute && item.type === 'SCREEN');
          if (foundedResource) {
            this._store$.dispatch(new SetCurrentResource(foundedResource));

          }
        }



        logger.print('GetResourcesSuccess finished', 'info');

        const route = this._router.url;
        const routeHistory = this.presenter.routeHistory;
        routeHistory.sort(function (a, b) {
          // Compare the 2 dates
          if (a.id < b.id) return -1;
          if (a.id > b.id) return 1;
          return 0;
        });
        //если мы закончили загрузку ресурсов и находимся на вкладке /login или / , то нужно сделать переход на страницу приложения
        if (route === '/login' || route === '/') {
          //если длинна истории переходов 0 или 1, то однозначно переходим на стратовую страницу,
          if (routeHistory.length < 2) {
            this._router.navigateByUrl('/' + this.configurationManager.configuration.start_page).catch(error => console.error(error));
          } else {
            //иначе ищем куда перейти. Идем с конца и ищем первую попавшуюся страницу, которая не / и не /login
            let founded = '';
            let i = routeHistory.length - 1;
            while (i >= 0 && !founded) {
              if (routeHistory[i].url !== '/' && routeHistory[i].url !== '/login') {
                founded = routeHistory[i].url;
              }
              i = i - 1;
            }
            //Если нашли, то переходим на нее
            if (founded) {
              const res = this.presenter.getResourceByFullUrl(founded);
              if (res) {
                this._router.navigateByUrl(founded).catch(error => console.error(error));
                this.presenter.setCurrentResource(res,true);
              } else {
                this._router.navigateByUrl(founded).catch(error => console.error(error));
              }
            } else {
              //Иначе идем на стартовую страницу
              this._router.navigateByUrl('/' + this.configurationManager.configuration.start_page).catch(error => console.error(error));
            }

          }
        }
        */
        //return new SetCurrentResource(curReport);
        this.loggerService.log('GetResourcesSuccess', 'Authentication', storeState.viewElements.displaySize, '', '', 'INFO', '', '0');

      }
    )
  ),{dispatch: false});

  SetCurrentResource$ = createEffect(() => this._actions$.pipe(
    ofType<SetCurrentResource>(EResourcesActions.SetCurrentResource),
    withLatestFrom(this._store$),
    tap(([action, storeState]) => {
        const idx = storeState.resources.data.resources.findIndex(itm => itm.code === action.payload.code);
        if (idx !== -1) {
          logger.success(`SetCurrentResource установлен ресурс с кодом ${action.payload.code}`);
          //return new SetCurrentResourceSuccess(action.payload);
          logger.print(`SetCurrentResource$ route ${this._router.url}`, 'info');
          this._store$.dispatch(new SetCurrentResourceSuccess(action.payload));
        } else {
          logger.error(`SetCurrentResource не найден ресурс с кодом ${action.payload.code}`);
          this._store$.dispatch(new SetCurrentResourceFailure());
        }
      }
    )
  ),{dispatch: false});

  TranslateResources$ = this._actions$.pipe(
    ofType<TranslateResources>(EResourcesActions.TranslateResources),
    withLatestFrom(this._store$),
    map(([action, storeState]) => {
      const newLanguage = action.payload;
      //todo: Вставить локализацию ресурсов.
      return storeState.resources.data;
    }),
    concatMap(payload => [
      new GetResourcesSuccess(payload)
    ])
  );

  constructor(
    private apiPlatformService: ApiPlatformService,
    private _actions$: Actions,
    private _store$: Store<IAppState>,
    private _router: Router,
    private configurationManager: ConfigurationManager,
    private presenter: Presenter,
    private loggerService: LoggerService
  ) {
  }

}

